import { InjectionToken } from '@angular/core';

export const storageProvider = new InjectionToken<Storage>('Storage');
